import { useScrollProgress } from '../hooks/use-scroll-progress';

/**
 * Barra de progresso de leitura, 2px, fixa no topo. A própria transição CSS
 * já é zerada globalmente sob `prefers-reduced-motion: reduce`
 * (`estilos.css`), então não precisa de guard aqui — só o cálculo de
 * progresso roda sempre.
 */
export function BarraProgresso(): JSX.Element {
  const progresso = useScrollProgress();

  return (
    <div
      className="barra-progresso w-full transition-transform duration-150 ease-out"
      style={{ transform: `scaleX(${progresso})` }}
      role="progressbar"
      aria-label="Progresso de leitura da página"
      aria-valuenow={Math.round(progresso * 100)}
      aria-valuemin={0}
      aria-valuemax={100}
    />
  );
}
